import React from 'react';
import { Star } from 'lucide-react';
import { motion } from 'framer-motion';
const reviews = [{
  name: 'Valentina',
  image: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=100&h=100&fit=crop&crop=face',
  text: 'Muy dulce y comprensiva. Realmente me ayudó a ver con claridad en un momento muy difícil. Incluso le escribí un par de veces después y siempre respondió. La recomiendo totalmente.'
}, {
  name: 'Kristina',
  image: 'https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=100&h=100&fit=crop&crop=face',
  text: 'Contacté a Ludmila en un momento emocional y confuso de mi vida. Me ayudó a entender lo que realmente estaba pasando y me guió en cómo seguir adelante. Su lectura fue increíblemente precisa, pero lo que más me conmovió fue su empatía.'
}, {
  name: 'Jennifer',
  image: 'https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=100&h=100&fit=crop&crop=face',
  text: 'Absolutamente amé el trabajo que hizo para mí. Me siento increíble y sigo recibiendo pequeñas bendiciones después de mi limpia. Su seguimiento es lo mejor — responde de inmediato y es muy dulce.'
}];
export function ReviewCards() {
  return <section className="w-full py-20 px-4" data-id="element-263">
      <div className="max-w-6xl mx-auto" data-id="element-264">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="font-playfair text-2xl sm:text-3xl md:text-4xl text-center text-white mb-12" data-id="element-265">
          Confiada por{' '}
          <span className="text-gradient-gold" data-id="element-266">+10,000 clientas felices</span>{' '}
          en todo el mundo
        </motion.h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-16" data-id="element-267">
          {reviews.map((review, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-[#111] border border-white/5 p-6 sm:p-8 rounded-2xl hover:border-[#D4AF37]/30 transition-colors" data-id="element-268">
              <div className="flex items-center gap-3 mb-4" data-id="element-269">
                <img src={review.image} alt={review.name} className="w-10 h-10 rounded-full object-cover border border-white/10" data-id="element-270" />
                <div data-id="element-271">
                  <p className="font-playfair text-white font-semibold" data-id="element-272">
                    {review.name}
                  </p>
                  <div className="flex gap-0.5" data-id="element-273">
                    {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-3 h-3 fill-[#D4AF37] text-[#D4AF37]" data-id="element-274" />)}
                  </div>
                </div>
              </div>
              <p className="font-inter text-gray-300 text-sm leading-relaxed" data-id="element-275">
                "{review.text}"
              </p>
            </motion.div>)}
        </div>

        {/* Stats Bar */}
        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-4 py-8 border-y border-white/10 text-center" data-id="element-276">
          <div className="flex flex-col items-center" data-id="element-277">
            <span className="text-2xl mb-1" data-id="element-278">🔮</span>
            <span className="font-inter text-xs text-gray-400 uppercase tracking-wider" data-id="element-279">
              +10 Años de Experiencia
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-280">
            <span className="text-2xl mb-1" data-id="element-281">⭐️</span>
            <span className="font-inter text-xs text-gray-400 uppercase tracking-wider" data-id="element-282">
              4.93/5 Calificación
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-283">
            <span className="text-2xl mb-1" data-id="element-284">🩷</span>
            <span className="font-inter text-xs text-gray-400 uppercase tracking-wider" data-id="element-285">
              +10,000 Clientas
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-286">
            <span className="text-2xl mb-1" data-id="element-287">🌍</span>
            <span className="font-inter text-xs text-gray-400 uppercase tracking-wider" data-id="element-288">
              +74 Países
            </span>
          </div>
        </div>

        {/* Video/GIF */}
        <div className="mt-12 flex justify-center" data-id="element-289">
          <div className="w-full max-w-2xl rounded-2xl overflow-hidden border border-white/10 shadow-2xl" data-id="element-290">
            <img src="https://assets.cdn.filesafe.space/tyFQ5dviGOYc3C9oyBAJ/media/695f5dd6d461d41bd3163bbc.gif" alt="Testimonio en video" className="w-full h-auto object-cover" data-id="element-291" />
          </div>
        </div>
      </div>
    </section>;
}